export default __webpack_public_path__ + "static/media/blog1.fef1669f.jpg";